import { I } from "./icons.jsx";

const LoadingGrid = () => (
  <div className="grid" data-testid="loading-grid">
    {Array.from({ length: 8 }).map((_, i) => (
      <div key={i} className="skeleton skel-card" />
    ))}
  </div>
);

const ErrorState = ({ error, onRetry }) => {
  const limited = error && error.status === 429;
  return (
    <div className="feed-state" data-testid="error-state">
      <div className="icon-wrap"><I.x size={20} /></div>
      <h3>{limited ? "Slow down a moment" : "Couldn't load this feed"}</h3>
      <p>
        {limited
          ? `Rate limited by the API — try again in ${error.retryAfter || 30}s.`
          : (error && error.message) || "The API returned an error."}
        {error && error.requestId ? ` · ref ${error.requestId}` : ""}
      </p>
      <button className="btn accent sm" data-testid="retry-button" onClick={onRetry}><I.spark size={12} /> Try again</button>
    </div>
  );
};

export { ErrorState, LoadingGrid };
